import { toolGroup, type ToolGroup } from "../../types";
import { autofillPlugin } from "../autofill/autofill";
import { sitesPlugin } from "../sites/sites";
import { skipToQcpPlugin } from "../skip-to-qcp/skip-to-qcp";
import { warpToStepPlugin } from "../warp-to-step/warp-to-step";

interface Site {
  name: string;
  description: string;
  href: string;
}

export interface JourneyGroupProps {
  journeyId?: string;
  site?: string;
  answerSets?: Record<string, [string, string][]>;
  fillJourneyAnswersPath?: string;
  fillCustomJourneyAnswersPath?: string;
  mainSites?: Site[];
  ukSites?: Site[];
  usSites?: Site[];
  verticals?: Record<string, string>;
  isDevelopment?: boolean;
}

// A group that needs runtime props is exported as a factory; drop the result
// straight into the DevToolsProvider items array. Each plugin reads the props
// it cares about and defaults the rest, so we forward the whole bag.
export function journeyGroup(props: JourneyGroupProps): ToolGroup {
  return toolGroup("Journey", [
    sitesPlugin({ ...props }),
    autofillPlugin({ ...props }),
    skipToQcpPlugin(),
    ...(props.isDevelopment ? [warpToStepPlugin()] : []),
  ]);
}
